import breadcrumbSchema from '../schemas/breadcrumb';
import courseSkeletonSchema from '../schemas/course';

const classSchema = ({ courseDetails = {}, classInfo }) => {
  const { goal } = courseDetails;
  if (!goal) return {};

  const graph = [];
  if (courseDetails.name) {
    graph.push(courseSkeletonSchema(courseDetails));
  }
  const breads = [
    {
      name: 'Home',
      url: 'https://unacademy.com'
    },
    {
      name: 'Explore',
      url: 'https://unacademy.com/explore'
    },
    {
      name: goal.name,
      url: goal.permalink
    },
    {
      name: 'Free classes & tests',
      url: `${goal.permalink}/classes`
    },
    {
      name: classInfo.name,
      url: classInfo.permalink
    }
  ];
  graph.push(breadcrumbSchema(breads));
  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };
  return schema;
};

export default classSchema;
